import type { FC } from 'react';

import FlexContainer from 'components/FlexContainer/FlexContainer';
import Typography from 'components/Typography/Typography';
import { useResponsive } from 'contexts/ResponsiveContext';
import { useUserProfile } from 'contexts/UserProfileContext';

import UserEditForm from './components/UserEditForm/UserEditForm';
import UserProfile from './components/UserProfile/UserProfile';
import useProfilePage from './hooks/useProfilePage';
import { MainContainerStyled } from './ProfilePage.styled';

const ProfilePage: FC = () => {
  const { isMobile } = useResponsive();
  const { handleSubmitForm } = useProfilePage();
  const { userProfile } = useUserProfile();

  return (
    <div>
      <MainContainerStyled>
        <Typography variant="h2" color="darkBlue">
          Profile Page
        </Typography>
        <FlexContainer align="start" justify="between" direction={isMobile ? 'column' : 'row'}>
          <UserProfile />
          {userProfile && <UserEditForm onSubmit={handleSubmitForm} />}
        </FlexContainer>
      </MainContainerStyled>
    </div>
  );
};

export default ProfilePage;
